/**
 * Asynchronously loads the component for Home
 */

import { lazyLoad } from 'utils/loadable';

export const SelectUnit = lazyLoad(
  () => import('./index'),
  module => module.default,
);
